import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import MyBadges from "./MyBadges";
import MyCertificates from "./MyCertificates";
import SideNav from "./SideNav";
import SideNavDetail from "./SideNavDetail";
import { scroller } from "react-scroll";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { learningPoints } from "../../redux/Cart/actions";
import Loader from "../../components/Loader/Loader";
import StaticUtils from "../../utils/StaticUtils";
import { leaderBoardData, leaderBoardDataTest } from "../../utils/testJson";
import ReactRoundedImage from "react-rounded-image";
import "./MenuDetailComponent.scss";
import {
  getLeaderBoardReq,
  getUserPointsReq,
  onUploadReqBroker,
  updateCoverPhoto,
  userDetailBroker,
} from "../../redux/user/actions";
import { SessionKeys } from "../../utils/AppUtils";
import moment from "moment";
import NotFoundImage from "../NewDesign/NotFound/NotFoundImage";
import { getActiveHeader } from "../../redux/home/actions";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import { loginResponse } from "../../redux/auth/actions";
import { FormGroup, Input } from "reactstrap";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import { Spinner, Overlay, Popover } from "react-bootstrap";
import ProfileDetailComponent from "./ProfileDetailComponent";
import EventDetailComponent from "./EventDetailComponent";
import OBLPDetailComponent from "./OBLPDetailComponent";
import CoachingNotesListComp from "./CoachingNotesListComp";
import ConfirmModal from "../modal/ConfirmModal";
import SimplePopup from "../modal/SimplePopup";

const MenuDetailComponent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const section = params.get("section");
  const user_id = params.get("user_id");
  const isOther =
    localStorage.getItem(SessionKeys.USER_ID) === user_id ? "0" : "1";

  const userDetailRes = useSelector((state) => state.user.userBroker);
  var userDetailResForOther = useSelector(
    (state) => state.user.userBrokerForOther
  );
  var uploadRes = useSelector((state) => state.user.uploadRes);
  const userRole = useSelector((state) => state.user.role);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const leaderBoardDataTestRes = useSelector((state) => state.user.leaderBoard);
  const userPointsRes = useSelector((state) => state.user.userPoints);
  const [totalLearningPoints, setTotalLearningPoints] = useState(0);
  const myLearningPointsRes = useSelector(
    (state) => state.carts?.learningPoints
  );
  const [isLoading, setIsLoading] = useState(true);

  const [leaderBoardData, setLeaderBoardData] = useState([]);
  const [lastUpdateTime, setLastUpdateTime] = useState("");
  const [coursePoints, setCoursePoints] = useState(0);
  const [videoPoints, setVideoPoints] = useState(0);
  const [rolePlayPoints, setRolePlayPoints] = useState(0);

  const [key, setKey] = useState("");
  const [userDetailState, setUserDetailState] = useState({});

  const handleFileUploadClick = () => {
    document.getElementById("exampleFileCover").click();
  };

  const [confirmModal, setConfirmModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");
  const [isConfirm, setIsConfirm] = useState();

  // console.log("Sectionnnnns", isOther);

  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const [showLimitPopup, setShowLimitPopup] = useState(false);
  const fileInputRef = useRef(null);
  const ref = useRef(null);

  const [name, setName] = useState("");
  const [role, setRole] = useState("");

  const nameLoader = useSelector((state) => state.home.showLoader);
  useEffect(() => {
    let userDetail = isOther === "1" ? userDetailResForOther : userDetailRes;
    if (!_.isEmpty(userDetail)) {
      let role = userDetail?.payload?.payload?.roles;
      if (role?.includes("staff")) {
        setRole("Support Staff");
      }else if (role?.includes("customer")) {
        setRole("");
      } else if (role?.includes("realtor")) {
        setRole("Real Estate Agent");
      } else if (role?.includes("manager")) {
        setRole("Manager");
      } else if (role?.includes("instructor")) {
        setRole("Instructor");
      } else if (role?.includes("host")) {
        setRole("host");
      } else if (role?.includes("broker_admin")) {
        setRole("admin");
      }
    }
  }, [userDetailRes, userDetailResForOther]);

  useEffect(() => {
    let userDetail = isOther === "1" ? userDetailResForOther : userDetailRes;
    if (!_.isEmpty(userDetail)) {
      setUserDetailState(userDetail?.payload?.payload);
    }
  }, [userDetailRes, userDetailResForOther]);

  useEffect(() => {
    let userDetail = isOther === "1" ? userDetailResForOther : userDetailRes;
    if (!_.isEmpty(userDetail)) {
      setName(
        `${userDetail.payload.payload.firstname}` +
          " " +
          `${userDetail.payload.payload.lastname}`
      );
    }
  }, [userDetailRes, userDetailResForOther]);

  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const removeCover = () => {
    onCoverPhotoUpload("", true);
  };

  const handleFileChange = (e) => {
    if (e.target.files[0] !== undefined && e.target.files[0] !== null) {
      // Handle the file upload logic here
      let file = e.target.files[0];

      if (file.size > 1048576) {
        // 1 MB in bytes
        setShowLimitPopup(true);
        e.target.value = ""; // clear the file input
        file = "";
      } else {
        onCoverPhotoUpload(e.target.files[0], false);
      }
    }
  };

  const [isCoverLoading, setisCoverLoading] = useState(true);
  const onCoverPhotoUpload = (value, isDelete) => {
    setShow(false);
    setIsLoading(true);
    const formData = new FormData();
    formData.append(
      "token",
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
    );
    formData.append("cover", isDelete ? "" : value);
    dispatch(updateCoverPhoto(formData));
  };

  var coverPhotoRes = useSelector((state) => state.user.coverPhoto);

  useEffect(() => {
    console.log("cover---", coverPhotoRes);
    if (coverPhotoRes?.status === "success") {
      authBroker.payload.user.user_cover_image = coverPhotoRes?.cover_url;
      dispatch(loginResponse(authBroker));
      dispatch(
        userDetailBroker({
          module: "getOrderDetailBroker",
          apiToken: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        })
      );
      setConfirmModal(true);
      setIsConfirm(false);
      setShowModalMsg(coverPhotoRes?.message);
      // alert(coverPhotoRes?.message);
      coverPhotoRes.status = "";
      // dispatch(updateCoverPhotoResponseClear());
    } else if (coverPhotoRes?.status === "error") {
      setConfirmModal(true);
      setIsConfirm(false);
      setShowModalMsg("Failed in updating cover image");
    }
    setIsLoading(false);
  }, [coverPhotoRes]);

  const classNameArr = [
    "points-one",
    "points-two",
    "points-theree",
    "points-four",
  ];

  useEffect(() => {
    dispatch(getActiveHeader(""));
    window.scrollTo(0, 0);
    // getLeaderBoardData();
    // getUserPoints();
  }, []);

  useEffect(() => {
    // console.log('leaderBoardDataTestRes: ',leaderBoardDataTestRes);
    if (!_.isEmpty(leaderBoardDataTestRes)) {
      if (leaderBoardDataTestRes?.status === "success") {
        // console.log('filteredArrayFromComponent1', StaticUtils.getLeaderBoardData(leaderBoardDataTestRes?.payload?.payload));
        setLeaderBoardData(
          leaderBoardDataTestRes?.payload?.payload?.list?.reverse()
        );
        setLastUpdateTime(
          moment
            .unix(leaderBoardDataTestRes?.payload?.payload?.last_updated)
            .format("Do MMMM YYYY, h:mm A")
        );
      }
    }
  }, [leaderBoardDataTestRes]);

  //get leader board
  // const getLeaderBoardData = () => {
  //   dispatch(
  //     getLeaderBoardReq({
  //       module: "leaderBoard",
  //       postData: {
  //         token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),

  //         user_id:
  //           isOther === "1"
  //             ? user_id
  //             : localStorage.getItem(SessionKeys.USER_ID),
  //       },
  //     })
  //   );
  // };

  useEffect(() => {
    if (!_.isEmpty(userPointsRes)) {
      if (userPointsRes?.status === "success") {
        // console.log("userPointsRes:", userPointsRes);
        // setLeaderBoardData(userPointsRes)
        setCoursePoints(
          userPointsRes?.payload?.payload?.course_lp !== null
            ? userPointsRes?.payload?.payload?.course_lp
            : 0
        );
        setVideoPoints(
          userPointsRes?.payload?.payload?.video_lp !== null
            ? userPointsRes?.payload?.payload?.video_lp
            : 0
        );
        setRolePlayPoints(
          userPointsRes?.payload?.payload?.role_play_lp !== null
            ? userPointsRes?.payload?.payload?.role_play_lp
            : 0
        );
        // let totalPoints =
        //   userPointsRes?.payload?.payload?.course_lp !== null
        //     ? Number(userPointsRes?.payload?.payload?.course_lp)
        //     : 0 + userPointsRes?.payload?.payload?.video_lp !== null
        //     ? Number(userPointsRes?.payload?.payload?.video_lp)
        //     : 0 + userPointsRes?.payload?.payload?.role_play_lp !== null
        //     ? Number(userPointsRes?.payload?.payload?.role_play_lp)
        //     : 0;

        let totalPoints =
          Number(userPointsRes?.payload?.payload?.course_lp) +
          Number(userPointsRes?.payload?.payload?.video_lp) +
          Number(userPointsRes?.payload?.payload?.role_play_lp);

        setTotalLearningPoints(totalPoints);
      }
    }
  }, [userPointsRes]);

  // const getUserPoints = () => {
  //   dispatch(
  //     getUserPointsReq({
  //       module: "userPoints",
  //       postData: {
  //         token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
  //         user_id:
  //           isOther === "1"
  //             ? user_id
  //             : localStorage.getItem(SessionKeys.USER_ID),
  //       },
  //     })
  //   );
  // };

  // useEffect(() => {
  //   if (!_.isEmpty(authBroker)) {
  //     dispatch(
  //       learningPoints({
  //         module: "learning-points/points",
  //         email: authBroker.payload.user.email,
  //       })
  //     );
  //   }
  //   setIsLoading(false);
  // }, [dispatch, authBroker]);

  useEffect(() => {
    // console.log("learningpoint", myLearningPointsRes);

    if (myLearningPointsRes?.status === "success") {
      var lpArray = myLearningPointsRes?.payload;

      let totalPoint = 0;
      if (!_.isEmpty(lpArray)) {
        if (_.isArray(lpArray) && lpArray.length > 0) {
          totalPoint = 0;
          for (let learningPoint of lpArray) {
            totalPoint = totalPoint + _.toNumber(learningPoint.point);
          }
        }
        myLearningPointsRes.payload = lpArray;
        // setTotalLearningPoints(totalPoint);
      }
    }
  }, [myLearningPointsRes]);

  useEffect(() => {
    switch (section) {
      case "dashboard":
        scroller.scrollTo("dashboardId", {
          duration: 50,
          delay: 0,
          smooth: "easeInOutQuart",
        });
        break;
      case "certificate":
        scroller.scrollTo("certificate", {
          duration: 50,
          delay: 0,
          smooth: "easeInOutQuart",
        });
        break;
      case "badge":
        scroller.scrollTo("badge", {
          duration: 50,
          delay: 0,
          smooth: "easeInOutQuart",
        });
        break;
      default: {
        scroller.scrollTo("editProfileId", {
          duration: 50,
          delay: 0,
          smooth: "easeInOutQuart",
        });
      }
    }
  }, [section]);

  const [isProfileLoading, setIsProfileLoading] = useState(true);
  const onUpload = (value, isDelete) => {
    console.log("value", value);
    setIsProfileLoading(true);
    const formData = new FormData();
    formData.append(
      "token",
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
    );
    formData.append("avatar", isDelete ? "" : value);
    dispatch(onUploadReqBroker(formData));
  };

  useEffect(() => {
    if (uploadRes?.status === "success") {
      authBroker.payload.user.profile_img = uploadRes.profile_img;
      dispatch(loginResponse(authBroker));
      dispatch(
        userDetailBroker({
          module: "getOrderDetailBroker",
          apiToken: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        })
      );
      // alert(uploadRes?.message);
      setConfirmModal(true);
      setIsConfirm(false);
      setShowModalMsg(uploadRes?.message);
      uploadRes.status = "";
    } else {
    }
    setIsProfileLoading(false);
  }, [uploadRes]);

  var coverPhotoRes = useSelector((state) => state.user.coverPhoto);
  useEffect(() => {
    console.log("cover---", coverPhotoRes, authBroker);
    if (coverPhotoRes?.status === "success") {
      authBroker.payload.user.user_cover_image = coverPhotoRes?.cover_url;
      dispatch(loginResponse(authBroker));
      dispatch(
        userDetailBroker({
          module: "getOrderDetailBroker",
          apiToken: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        })
      );
      setConfirmModal(true);
      setIsConfirm(false);
      setShowModalMsg(coverPhotoRes?.message);
      // alert(coverPhotoRes?.message);
      coverPhotoRes.status = "";
      // dispatch(updateCoverPhotoResponseClear());
    } else if (coverPhotoRes?.status === "error") {
      setConfirmModal(true);
      setIsConfirm(false);
      setShowModalMsg("Failed in updating cover image");
    }
    setIsLoading(false);
  }, [coverPhotoRes]);

  const tab = params.get("tab");

  useEffect(() => {
    renderComp();
  }, [tab]);

  useEffect(() => {
    if (tab === "1") {
      setKey("personaldetail");
    } else if (tab === "2") {
      setKey("course");
    } else if (tab === "3") {
      setKey("videos");
    } else if (tab === "4") {
      setKey("events");
    } else if (tab === "5") {
      setKey("certifications");
    } else if (tab === "6") {
      setKey("certificates");
    } else if (tab === "7") {
      setKey("badges");
    } else if (tab === "8") {
      setKey("learningpath");
    } else if (tab === "9") {
      setKey("onboarding");
    } else if (tab === "10") {
      setKey("coachingnotes");
    }
  }, [tab]);

  const renderComp = () => {
    if (tab === "1") {
      return <SideNavDetail setIsLoading={setIsLoading} />;
    } else if (tab === "2") {
      return (
        <ProfileDetailComponent
          isVideos={false}
          userId={
            _.toNumber(isOther) ? user_id : localStorage.getItem("USER_ID")
          }
          setIsLoading={setIsLoading}
          isOther={isOther}
        />
      );
    } else if (tab === "3") {
      return (
        <ProfileDetailComponent
          isVideos={true}
          userId={
            _.toNumber(isOther) ? user_id : localStorage.getItem("USER_ID")
          }
          setIsLoading={setIsLoading}
          isOther={isOther}
        />
      );
    } else if (tab === "4") {
      return (
        <EventDetailComponent
          userId={
            _.toNumber(isOther) ? user_id : localStorage.getItem("USER_ID")
          }
          setIsLoading={setIsLoading}
          isEvent={true}
          isOther={isOther}
        />
      );
    } else if (tab === "5") {
      return (
        <EventDetailComponent
          userId={
            _.toNumber(isOther) ? user_id : localStorage.getItem("USER_ID")
          }
          setIsLoading={setIsLoading}
          isEvent={false}
          isOther={isOther}
        />
      );
    } else if (tab === "6") {
      return <MyCertificates isOther={isOther} setIsLoading={setIsLoading} />;
      return "tab6";
    } else if (tab === "7") {
      return <MyBadges isOther={isOther} setIsLoading={setIsLoading} />;
      return "tab7";
    } else if (tab === "8") {
      return (
        <OBLPDetailComponent
          isOB={0}
          userId={
            _.toNumber(isOther) ? user_id : localStorage.getItem("USER_ID")
          }
          setIsLoading={setIsLoading}
          isOther={isOther}
        />
      );
    } else if (tab === "9") {
      return (
        <OBLPDetailComponent
          isOB={1}
          userId={
            _.toNumber(isOther) ? user_id : localStorage.getItem("USER_ID")
          }
          setIsLoading={setIsLoading}
          isOther={isOther}
        />
      );
    } else if (tab === "10") {
      return <CoachingNotesListComp key={key} />;
    } else {
      return <SideNavDetail setIsLoading={setIsLoading} />;
    }
  };

  return (
    <>
      <Loader start={isLoading} />

      <section className="new-profile-page-b2b">
        <div
          className="profile-header"
          style={{
            backgroundImage: `url(${
              userDetailState?.user_cover_image
                ? userDetailState?.user_cover_image
                : "/images/bg-cover.png"
            })`,
          }}
        >
          <div className="profile-header-img">
            <div className="container">
              <div className="row">
                <div className="row-prfile col-md-12 d-flex justify-content-between gap-2 align-items-center">
                  <div className="user-info-header">
                    {/* <img src="/images/avatar.png" alt="Sarine Steward" /> */}
                    {isProfileLoading ? (
                      <ShimmerScreen
                        case={"circle"}
                        height={"194px"}
                        width={"194px"}
                      />
                    ) : (
                      <div className="prfile-obx">
                        <ReactRoundedImage
                          id="profileImg"
                          image={
                            userDetailState?.profile_img !== undefined &&
                            userDetailState?.profile_img !== ""
                              ? userDetailState?.profile_img
                              : "/images/avatar.png"
                          }
                          roundedSize="0"
                          imageWidth="194"
                          imageHeight="194"
                        />
                        {isOther === "1" ? (
                          ""
                        ) : (
                          <div className="img-profile_visbty">
                            <FormGroup>
                              <svg
                                className="img-fluid profileICON"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                id="More"
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                              >
                                <defs>
                                  <linearGradient
                                    id="linear-gradient"
                                    y1="0.5"
                                    x2="1"
                                    y2="0.5"
                                    gradientUnits="objectBoundingBox"
                                  >
                                    <stop offset="0" stopColor="#00b7f1" />
                                    <stop offset="1" stopColor="#ed156e" />
                                  </linearGradient>
                                </defs>
                                <circle
                                  id="Ellipse_57"
                                  data-name="Ellipse 57"
                                  cx="15"
                                  cy="15"
                                  r="15"
                                  fill="url(#linear-gradient)"
                                />
                                <circle
                                  id="Ellipse_179"
                                  data-name="Ellipse 179"
                                  cx="13"
                                  cy="13"
                                  r="13"
                                  transform="translate(2 2)"
                                  fill="#fff"
                                />
                                <g
                                  id="Group_2342"
                                  data-name="Group 2342"
                                  transform="translate(-775 -762)"
                                >
                                  <circle
                                    id="Ellipse_183"
                                    data-name="Ellipse 183"
                                    cx="2"
                                    cy="2"
                                    r="2"
                                    transform="translate(782 775)"
                                    fill="#774d9f"
                                  />
                                  <circle
                                    id="Ellipse_184"
                                    data-name="Ellipse 184"
                                    cx="2"
                                    cy="2"
                                    r="2"
                                    transform="translate(788 775)"
                                    fill="#774d9f"
                                  />
                                  <circle
                                    id="Ellipse_185"
                                    data-name="Ellipse 185"
                                    cx="2"
                                    cy="2"
                                    r="2"
                                    transform="translate(794 775)"
                                    fill="#774d9f"
                                  />
                                </g>
                              </svg>

                              <Input
                                type="file"
                                name="file"
                                accept="image/png,image/jpeg"
                                id="exampleFile"
                                innerRef={fileInputRef}
                                onChange={(e) => {
                                  // console.log('Profile Image:', e.target.files[0]);
                                  if (
                                    e.target.files[0] !== undefined &&
                                    e.target.files[0] !== null
                                  )
                                    onUpload(e.target.files[0], false);
                                  fileInputRef.current.value = null;
                                }}
                              />

                              {isProfileLoading ? (
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                  variant="primary"
                                />
                              ) : (
                                ""
                              )}
                            </FormGroup>
                            {userDetailState?.profile_img !== undefined &&
                            userDetailState?.profile_img !== "" ? (
                              <div
                                className="delete-iamge-pointer"
                                onClick={() => {
                                  onUpload(null, true);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="30"
                                  height="30"
                                  viewBox="0 0 30 30"
                                >
                                  <defs>
                                    <linearGradient
                                      id="linear-gradient"
                                      x2="1"
                                      y1="0.5"
                                      y2="0.5"
                                      gradientUnits="objectBoundingBox"
                                    >
                                      <stop
                                        offset="0"
                                        stopColor="#00b7f1"
                                      ></stop>
                                      <stop
                                        offset="1"
                                        stopColor="#ed156e"
                                      ></stop>
                                    </linearGradient>
                                  </defs>
                                  <circle
                                    cx="15"
                                    cy="15"
                                    r="15"
                                    fill="url(#linear-gradient)"
                                    data-name="Ellipse 57"
                                  ></circle>
                                  <circle
                                    cx="13"
                                    cy="13"
                                    r="13"
                                    fill="#fff"
                                    data-name="Ellipse 179"
                                    transform="translate(2 2)"
                                  ></circle>
                                  <path
                                    fill="#7a549e"
                                    d="M10.582.784h-2.94l-.23-.458A.588.588 0 006.885 0h-2.8a.581.581 0 00-.524.326l-.23.458H.392A.392.392 0 000 1.176v.784a.392.392 0 00.392.392h10.19a.392.392 0 00.392-.392v-.784a.392.392 0 00-.392-.392zM1.3 11.439a1.176 1.176 0 001.173 1.1H8.5a1.176 1.176 0 001.173-1.1l.519-8.3H.784z"
                                    data-name="Icon awesome-trash"
                                    transform="translate(9.514 8.729)"
                                  ></path>
                                </svg>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        )}
                      </div>
                    )}
                    <div className="info-user">
                      {isOther === "0" ? <h1>My Profile</h1> : ""}
                      {_.isEmpty(name) && _.isEmpty(role) ? (
                        <ShimmerScreen
                          case="rect"
                          height="2rem"
                          width="5rem"
                        />
                      ) : (
                        <>
                          <h4>{name}</h4>
                          <p>{role}</p>
                        </>
                      )}
                    </div>
                  </div>
                  {isOther === "0" ? (
                    <div className="btn-cover-img" ref={ref}>
                      <label id="exampleFile" for="exampleFile" className="">
                        <button
                          className="upload-button"
                          // disabled={isCoverLoading}
                          onClick={handleClick}
                        >
                          {" "}
                          Edit Cover
                        </button>
                      </label>
                      <Overlay
                        show={show}
                        target={target}
                        placement="bottom"
                        container={ref.current}
                        containerPadding={20}
                      >
                        <Popover id="popover-contained">
                          <Popover.Body>
                            <FormGroup>
                              <input
                                type="file"
                                name="file"
                                accept="image/png,image/jpeg"
                                id="exampleFileCover"
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                              />
                            </FormGroup>
                            <div className="d-flex gap-3 flex-column justify-content-between">
                              <button
                                className="linkbtn"
                                onClick={handleFileUploadClick}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width={24}
                                  height={24}
                                  fill="currentColor"
                                >
                                  <path d="M3 19H21V21H3V19ZM13 5.82843V17H11V5.82843L4.92893 11.8995L3.51472 10.4853L12 2L20.4853 10.4853L19.0711 11.8995L13 5.82843Z"></path>
                                </svg>{" "}
                                Upload Cover
                              </button>
                              {userDetailState?.user_cover_image ? (
                                <button
                                  className="linkbtn"
                                  onClick={() => removeCover()}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width={24}
                                    height={24}
                                    fill="currentColor"
                                  >
                                    <path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z"></path>
                                  </svg>{" "}
                                  Remove Cover
                                </button>
                              ) : (
                                ""
                              )}
                            </div>
                          </Popover.Body>
                        </Popover>
                      </Overlay>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="user-info-tab">
          <div className="container-fluid">
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey="personaldetail"
              activeKey={key}
            >
              <Row>
                <Col className="ps-md-0 col-xl-3 col-lg-3">
                  <Nav
                    variant="pills"
                    className="flex-md-column"
                    onSelect={(k) => {
                      console.log("selectKey: ", k);
                      setKey(k);
                      if (k === "personaldetail") {
                        navigate(
                          `/profile/edit?section=edit&tab=1&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : localStorage.getItem("USER_ID")
                          }`
                        );
                      } else if (k === "course") {
                        navigate(
                          `/profile/edit?section=edit&tab=2&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : localStorage.getItem("USER_ID")
                          }`
                        );
                      } else if (k === "videos") {
                        navigate(
                          `/profile/edit?section=edit&tab=3&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : localStorage.getItem("USER_ID")
                          }`
                        );
                      } else if (k === "events") {
                        navigate(
                          `/profile/edit?section=edit&tab=4&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : localStorage.getItem("USER_ID")
                          }`
                        );
                      } else if (k === "certifications") {
                        navigate(
                          `/profile/edit?section=edit&tab=5&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : localStorage.getItem("USER_ID")
                          }`
                        );
                      } else if (k === "certificates") {
                        navigate(
                          `/profile/edit?section=edit&tab=6&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : localStorage.getItem("USER_ID")
                          }`
                        );
                      } else if (k === "badges") {
                        navigate(
                          `/profile/edit?section=edit&tab=7&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : localStorage.getItem("USER_ID")
                          }`
                        );
                      } else if (k === "learningpath") {
                        navigate(
                          `/profile/edit?section=edit&tab=8&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : localStorage.getItem("USER_ID")
                          }`
                        );
                      } else if (k === "onboarding") {
                        navigate(
                          `/profile/edit?section=edit&tab=9&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : localStorage.getItem("USER_ID")
                          }`
                        );
                      } else if (k === "coachingnotes") {
                        navigate(
                          `/profile/edit?section=edit&tab=10&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : localStorage.getItem("USER_ID")
                          }`
                        );
                      }
                    }}
                  >
                    <Nav.Item>
                      <Nav.Link eventKey="personaldetail">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.6667 28C17.9303 28 17.3333 27.4031 17.3333 26.6667V16C17.3333 15.2636 17.9303 14.6667 18.6667 14.6667H26.6667C27.4031 14.6667 28 15.2636 28 16V26.6667C28 27.4031 27.4031 28 26.6667 28H18.6667ZM5.33333 17.3333C4.59696 17.3333 4 16.7364 4 16V5.33333C4 4.59696 4.59696 4 5.33333 4H13.3333C14.0697 4 14.6667 4.59696 14.6667 5.33333V16C14.6667 16.7364 14.0697 17.3333 13.3333 17.3333H5.33333ZM12 14.6667V6.66667H6.66667V14.6667H12ZM5.33333 28C4.59696 28 4 27.4031 4 26.6667V21.3333C4 20.5969 4.59696 20 5.33333 20H13.3333C14.0697 20 14.6667 20.5969 14.6667 21.3333V26.6667C14.6667 27.4031 14.0697 28 13.3333 28H5.33333ZM6.66667 25.3333H12V22.6667H6.66667V25.3333ZM20 25.3333H25.3333V17.3333H20V25.3333ZM17.3333 5.33333C17.3333 4.59696 17.9303 4 18.6667 4H26.6667C27.4031 4 28 4.59696 28 5.33333V10.6667C28 11.403 27.4031 12 26.6667 12H18.6667C17.9303 12 17.3333 11.403 17.3333 10.6667V5.33333ZM20 6.66667V9.33333H25.3333V6.66667H20Z"
                            fill="black"
                            fillOpacity="0.6"
                          />
                        </svg>{" "}
                        Personal Details
                      </Nav.Link>
                    </Nav.Item>
                    {userRole !== "instructor" && userRole !== "host" && (
                      <>
                        <Nav.Item>
                          <Nav.Link eventKey="course">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M22.6668 20.3269V29.4889C22.6668 29.857 22.3683 30.1557 22.0002 30.1557C21.8794 30.1557 21.7608 30.1227 21.6572 30.0606L16.0002 26.6663L10.3432 30.0606C10.0274 30.2499 9.61794 30.1475 9.4285 29.8319C9.36634 29.7282 9.3335 29.6097 9.3335 29.4889V20.3269C6.89492 18.3721 5.3335 15.3682 5.3335 11.9997C5.3335 6.10863 10.1091 1.33301 16.0002 1.33301C21.8912 1.33301 26.6668 6.10863 26.6668 11.9997C26.6668 15.3682 25.1054 18.3721 22.6668 20.3269ZM12.0002 21.891V25.9565L16.0002 23.5565L20.0002 25.9565V21.891C18.765 22.391 17.4147 22.6663 16.0002 22.6663C14.5856 22.6663 13.2354 22.391 12.0002 21.891ZM16.0002 19.9997C20.4184 19.9997 24.0002 16.4179 24.0002 11.9997C24.0002 7.58139 20.4184 3.99967 16.0002 3.99967C11.5819 3.99967 8.00016 7.58139 8.00016 11.9997C8.00016 16.4179 11.5819 19.9997 16.0002 19.9997Z"
                                fill="black"
                              />
                            </svg>{" "}
                            Courses
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="videos">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5.33317 25.3333V6.66667H12.7809L15.4476 9.33333H26.6665V25.3333H5.33317ZM27.9998 6.66667H16.5521L13.8854 4H3.99984C3.26346 4 2.6665 4.59696 2.6665 5.33333V26.6667C2.6665 27.4031 3.26346 28 3.99984 28H27.9998C28.7362 28 29.3332 27.4031 29.3332 26.6667V8C29.3332 7.26363 28.7362 6.66667 27.9998 6.66667ZM20.0009 16.8893L13.4957 12.5525C13.4081 12.4941 13.3052 12.4629 13.1998 12.4629C12.9053 12.4629 12.6665 12.7017 12.6665 12.9962V21.6699C12.6665 21.7752 12.6977 21.8781 12.7561 21.9657C12.9194 22.2108 13.2506 22.2771 13.4957 22.1136L20.0009 17.7768C20.0594 17.7377 20.1097 17.6875 20.1488 17.6289C20.3122 17.3839 20.246 17.0527 20.0009 16.8893Z"
                                fill="black"
                                fillOpacity="0.6"
                              />
                            </svg>{" "}
                            Videos
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="events">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.9998 1.33301V3.99967H19.9998V1.33301H22.6665V3.99967H27.9998C28.7362 3.99967 29.3332 4.59663 29.3332 5.33301V26.6663C29.3332 27.4027 28.7362 27.9997 27.9998 27.9997H3.99984C3.26346 27.9997 2.6665 27.4027 2.6665 26.6663V5.33301C2.6665 4.59663 3.26346 3.99967 3.99984 3.99967H9.33317V1.33301H11.9998ZM26.6665 14.6663H5.33317V25.333H26.6665V14.6663ZM14.6665 17.333V22.6663H7.99984V17.333H14.6665ZM9.33317 6.66634H5.33317V11.9997H26.6665V6.66634H22.6665V9.33301H19.9998V6.66634H11.9998V9.33301H9.33317V6.66634Z"
                                fill="black"
                                fillOpacity="0.6"
                              />
                            </svg>{" "}
                            Events
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="certifications">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10.6003 10.1015H20.8949C20.9457 10.1015 20.988 10.1438 20.988 10.1946C20.988 10.8612 20.988 10.4168 20.988 11.0812C20.988 11.132 20.9457 11.1743 20.8949 11.1743H10.6003C10.5389 11.1743 10.4882 11.1235 10.4882 11.0622C10.4882 10.4083 10.4882 10.8654 10.4882 10.2115C10.4882 10.1523 10.5389 10.1015 10.6003 10.1015ZM7.95735 4.52991H9.60999V3.49304C9.60999 3.22219 9.88085 3 10.2131 3C10.5453 3 10.8161 3.22219 10.8161 3.49304V4.52779H13.4401V3.49304C13.4401 3.22219 13.7109 3 14.041 3C14.3732 3 14.6441 3.22219 14.6441 3.49304V4.52779H17.268V3.49304C17.268 3.22219 17.5389 3 17.8711 3C18.2033 3 18.4742 3.22219 18.4742 3.49304V4.52779H21.0981V3.49304C21.0981 3.22219 21.3689 3 21.7011 3C22.0334 3 22.3042 3.22219 22.3042 3.49304V4.52779H23.5188C24.5959 4.52779 25.4762 5.40807 25.4762 6.48515V27.0426C25.4762 28.1197 24.5959 29 23.5188 29H7.95735C6.88028 29 6 28.1197 6 27.0426V6.48726C6 5.41019 6.88028 4.52991 7.95735 4.52991ZM8.11394 6.19525H9.60999V6.92952C9.60999 7.20037 9.88085 7.42256 10.2131 7.42256C10.5453 7.42256 10.8161 7.20037 10.8161 6.92952V6.19525H13.4401V6.92952C13.4401 7.20037 13.7109 7.42256 14.0431 7.42256C14.3754 7.42256 14.6462 7.20037 14.6462 6.92952V6.19525H17.2701V6.92952C17.2701 7.20037 17.541 7.42256 17.8732 7.42256C18.2054 7.42256 18.4763 7.20037 18.4763 6.92952V6.19525H21.1002V6.92952C21.1002 7.20037 21.371 7.42256 21.7033 7.42256C22.0355 7.42256 22.3063 7.20037 22.3063 6.92952V6.19525H23.3644C23.667 6.19525 23.9167 6.44494 23.9167 6.74754V26.7824C23.9167 27.0829 23.667 27.3347 23.3644 27.3347H8.11394C7.81346 27.3347 7.56165 27.0871 7.56165 26.7824V6.74754C7.56165 6.44494 7.81135 6.19525 8.11394 6.19525ZM10.6003 25.1953H20.8949C20.9457 25.1953 20.988 25.153 20.988 25.1022C20.988 24.4357 20.988 24.88 20.988 24.2156C20.988 24.1648 20.9457 24.1225 20.8949 24.1225H10.6003C10.5389 24.1225 10.4882 24.1733 10.4882 24.2346C10.4882 24.8123 10.4882 24.5076 10.4882 25.0853C10.4882 25.1445 10.5389 25.1953 10.6003 25.1953ZM10.6003 21.6911H20.8949C20.9457 21.6911 20.988 21.6488 20.988 21.598C20.988 20.9315 20.988 21.4774 20.988 20.813C20.988 20.7622 20.9457 20.7199 20.8949 20.7199H10.6003C10.5389 20.7199 10.4882 20.7707 10.4882 20.832C10.4882 21.4859 10.4882 20.9272 10.4882 21.5811C10.4882 21.6404 10.5389 21.6911 10.6003 21.6911ZM10.6003 18.1848H20.8949C20.9457 18.1848 20.988 18.1425 20.988 18.0917C20.988 17.4252 20.988 17.768 20.988 17.1035C20.988 17.0527 20.9457 17.0104 20.8949 17.0104H10.6003C10.5389 17.0104 10.4882 17.0612 10.4882 17.1226C10.4882 17.7764 10.4882 17.4209 10.4882 18.0748C10.4882 18.134 10.5389 18.1848 10.6003 18.1848ZM10.6003 14.6806H20.8949C20.9457 14.6806 20.988 14.6383 20.988 14.5875C20.988 13.921 20.988 14.3653 20.988 13.7009C20.988 13.6501 20.9457 13.6078 20.8949 13.6078H10.6003C10.5389 13.6078 10.4882 13.6586 10.4882 13.7199C10.4882 14.3738 10.4882 13.9167 10.4882 14.5706C10.4882 14.6299 10.5389 14.6806 10.6003 14.6806Z"
                                fill="black"
                                fillOpacity="0.6"
                              />
                            </svg>{" "}
                            Certifications
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="certificates">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M16.0002 9.33304C21.8912 9.33304 26.6668 14.1087 26.6668 19.9997C26.6668 25.8908 21.8912 30.6664 16.0002 30.6664C10.1091 30.6664 5.3335 25.8908 5.3335 19.9997C5.3335 14.1087 10.1091 9.33304 16.0002 9.33304ZM16.0002 11.9997C11.5819 11.9997 8.00016 15.5815 8.00016 19.9997C8.00016 24.418 11.5819 27.9997 16.0002 27.9997C20.4184 27.9997 24.0002 24.418 24.0002 19.9997C24.0002 15.5815 20.4184 11.9997 16.0002 11.9997ZM16.0002 13.9997L17.7635 17.5727L21.7066 18.1456L18.8534 20.9268L19.5268 24.8539L16.0002 22.9997L12.4735 24.8539L13.147 20.9268L10.2938 18.1456L14.2368 17.5727L16.0002 13.9997ZM24.0002 2.66637V6.66637L22.1823 8.18312C20.7075 7.40999 19.0702 6.90484 17.335 6.73236L17.3335 2.66504L24.0002 2.66637ZM14.6668 2.66504L14.6664 6.73224C12.9314 6.90456 11.2941 7.40952 9.81938 8.18243L8.00016 6.66637V2.66637L14.6668 2.66504Z"
                                fill="black"
                                fillOpacity="0.6"
                              />
                            </svg>{" "}
                            Certificates
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="badges">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.3431 2.80535C11.4742 2.20039 9.44275 3.04187 8.54908 4.79107L7.47471 6.89397C7.34706 7.14383 7.14383 7.34705 6.89398 7.4747L4.79107 8.54907C3.04187 9.44274 2.2004 11.4742 2.80535 13.343L3.53263 15.5897C3.61904 15.8566 3.61904 16.1441 3.53263 16.411L2.80535 18.6577C2.2004 20.5265 3.04188 22.558 4.79107 23.4516L6.89398 24.526C7.14383 24.6537 7.34706 24.8569 7.47471 25.1068L8.54908 27.2096C9.44275 28.9588 11.4743 29.8002 13.3431 29.1953L15.5897 28.4681C15.8567 28.3817 16.144 28.3817 16.4109 28.4681L18.6576 29.1953C20.5264 29.8002 22.558 28.9588 23.4516 27.2096L24.526 25.1068C24.6536 24.8569 24.8568 24.6537 25.1067 24.526L27.2096 23.4516C28.9588 22.558 29.8003 20.5265 29.1953 18.6577L28.468 16.411C28.3816 16.1441 28.3816 15.8566 28.468 15.5897L29.1953 13.343C29.8003 11.4742 28.9588 9.44274 27.2096 8.54907L25.1067 7.4747C24.8568 7.34705 24.6536 7.14382 24.526 6.89397L23.4516 4.79107C22.558 3.04187 20.5264 2.20039 18.6576 2.80535L16.4109 3.53262C16.144 3.61903 15.8567 3.61903 15.5897 3.53262L13.3431 2.80535ZM10.9238 6.0043C11.2217 5.42123 11.8988 5.14075 12.5218 5.34239L14.7684 6.06967C15.5692 6.32891 16.4315 6.32891 17.2323 6.06967L19.4789 5.34239C20.1019 5.14075 20.7791 5.42123 21.0769 6.0043L22.1513 8.10721C22.5343 8.85678 23.1439 9.46643 23.8935 9.84939L25.9964 10.9238C26.5795 11.2217 26.86 11.8988 26.6583 12.5218L25.9311 14.7685C25.6717 15.5693 25.6717 16.4314 25.9311 17.2322L26.6583 19.4789C26.86 20.1018 26.5795 20.779 25.9964 21.0769L23.8935 22.1513C23.1439 22.5342 22.5343 23.144 22.1513 23.8934L21.0769 25.9964C20.7791 26.5794 20.1019 26.86 19.4789 26.6582L17.2323 25.931C16.4315 25.6718 15.5692 25.6718 14.7684 25.931L12.5218 26.6582C11.8988 26.86 11.2217 26.5794 10.9238 25.9964L9.8494 23.8934C9.46644 23.144 8.85678 22.5342 8.10722 22.1513L6.00431 21.0769C5.42124 20.779 5.14075 20.1018 5.3424 19.4789L6.06968 17.2322C6.32891 16.4314 6.32891 15.5693 6.06968 14.7685L5.3424 12.5218C5.14075 11.8988 5.42124 11.2217 6.00431 10.9238L8.1072 9.84939C8.85678 9.46643 9.46644 8.85678 9.8494 8.10721L10.9238 6.0043ZM9.01312 15.6769L14.67 21.3337L24.0981 11.9056L22.2125 10.02L14.67 17.5625L10.8987 13.7912L9.01312 15.6769Z"
                                fill="black"
                                fillOpacity="0.6"
                              />
                            </svg>{" "}
                            Badges
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="learningpath">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5.33333 15.1114L0 12.0003L16 2.66699L32 12.0003V23.3337H29.3333V13.5559L26.6667 15.1114V24.0154L26.3699 24.3822C23.9276 27.4002 20.1891 29.3337 16 29.3337C11.8109 29.3337 8.07239 27.4002 5.63017 24.3822L5.33333 24.0154V15.1114ZM8 16.667V23.0559C9.95628 25.2723 12.8148 26.667 16 26.667C19.1852 26.667 22.0437 25.2723 24 23.0559V16.667L16 21.3337L8 16.667ZM5.29236 12.0003L16 18.2465L26.7076 12.0003L16 5.75421L5.29236 12.0003Z"
                                fill="black"
                                fillOpacity="0.6"
                              />
                            </svg>{" "}
                            Learning Paths
                          </Nav.Link>
                        </Nav.Item>
                        {!userDetailState?.roles?.includes("customer") && (
                          <Nav.Item>
                            <Nav.Link eventKey="onboarding">
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0.814264 12.2132L1.39156 19.3591C1.46937 20.0971 1.64256 20.5714 1.8534 20.8325C1.94092 20.9312 2.05426 21.0034 2.18066 21.0411C2.30706 21.0788 2.44147 21.0805 2.56874 21.0458H2.63651H5.46778C5.62273 21.0619 5.77925 21.0401 5.92394 20.9824C6.06863 20.9247 6.19719 20.8328 6.29859 20.7145L6.31114 20.6995C6.5196 20.3523 6.62251 19.952 6.60731 19.5474V11.6585C6.59498 11.6239 6.58902 11.5873 6.58974 11.5506C6.58851 11.5406 6.58851 11.5304 6.58974 11.5204C6.57847 11.4152 6.5446 11.3136 6.49045 11.2226C6.4363 11.1316 6.36315 11.0534 6.276 10.9933C5.97621 10.8379 5.63869 10.77 5.30212 10.7976H1.75802C1.61161 10.7895 1.4651 10.8115 1.32744 10.862C1.18978 10.9124 1.06385 10.9905 0.957333 11.0912C0.789164 11.292 0.728924 11.6384 0.811754 12.178V12.2132H0.814264ZM23.369 11.9095C23.3686 11.7895 23.3762 11.6696 23.3916 11.5506L22.0889 10.6746C21.9007 10.5491 21.6948 10.4035 21.4865 10.2579C20.7335 9.73583 19.9805 9.19869 19.1447 8.98033C18.6573 8.85471 18.157 8.78565 17.6538 8.77451C17.1922 8.76263 16.7312 8.81329 16.2833 8.92511C16.0222 8.99131 15.7695 9.08732 15.5303 9.21124C15.3197 9.32228 15.1248 9.46069 14.9505 9.62288L14.057 10.6695C14.03 10.7205 13.9923 10.765 13.9465 10.8001L11.5194 13.6891C11.5507 13.8587 11.6231 14.0182 11.7302 14.1534C11.8478 14.2973 12.0022 14.4066 12.177 14.4697C12.3794 14.5422 12.5955 14.5688 12.8095 14.5475C13.2167 14.5079 13.6029 14.348 13.9189 14.0881L14.5941 13.5234C14.7648 13.3828 14.9078 13.2523 15.0484 13.1243C15.3387 12.8422 15.6565 12.59 15.9972 12.3713C16.7502 11.9195 17.5032 11.9045 18.2562 13.1544L22.0713 20.0494H23.369V11.9095ZM23.6777 10.8076C23.7365 10.7254 23.8038 10.6497 23.8785 10.5817C24.2808 10.2609 24.7883 10.1016 25.3017 10.1349H28.6149C29.3102 10.1349 29.8699 10.2579 30.2665 10.5591C30.7007 10.8954 30.9065 11.405 30.8187 12.1379L30.0857 19.7206C30.0737 20.2905 29.8803 20.8418 29.5335 21.2943C29.3559 21.4935 29.1337 21.6477 28.885 21.7446C28.6364 21.8414 28.3684 21.8781 28.1028 21.8515H25.1235C24.7382 21.8817 24.3559 21.7642 24.0542 21.5227C23.824 21.3309 23.6396 21.0899 23.5146 20.8174H22.483C22.6133 21.1833 22.6203 21.5817 22.5031 21.9519C22.3871 22.2993 22.1715 22.6048 21.8831 22.8304C21.6008 23.0534 21.2666 23.201 20.9117 23.2596C20.5589 23.319 20.1965 23.2791 19.8651 23.1442C19.5337 23.5137 19.1075 23.7853 18.6327 23.9298C18.1996 24.0478 17.7404 24.0268 17.3199 23.8696C16.9599 24.3012 16.4707 24.6057 15.9244 24.738C15.358 24.8433 14.7728 24.7549 14.2628 24.487C14.0875 24.6257 13.8941 24.7397 13.688 24.8259C13.4058 24.9426 13.1021 24.9982 12.7969 24.989C12.1934 25.0007 11.6071 24.7868 11.1529 24.3891C10.777 24.0169 10.4649 23.5852 10.2292 23.1116L8.58267 20.2502H7.3076C7.24996 20.5781 7.12053 20.8892 6.92859 21.1613L6.91102 21.1864C6.73654 21.4017 6.51185 21.5708 6.25669 21.6789C6.00154 21.787 5.72373 21.8308 5.4477 21.8064H2.66412C2.41037 21.8625 2.14608 21.848 1.90001 21.7643C1.65395 21.6807 1.43554 21.5311 1.26857 21.332C0.942273 20.953 0.716374 20.328 0.620995 19.4319V19.3993L0.0436977 12.281C-0.0717617 11.5129 0.0436977 10.9682 0.364976 10.5968C0.538004 10.4101 0.74885 10.2625 0.983442 10.1638C1.21803 10.0652 1.47098 10.0177 1.72539 10.0245H5.2971C5.7842 9.99253 6.27006 10.1033 6.69516 10.3432C6.99118 10.5317 7.2081 10.8218 7.30509 11.159H9.70213C10.2504 10.7661 10.8534 10.4557 11.4917 10.2378C12.16 10.037 12.8637 9.98221 13.555 10.0772L14.3757 9.1008L14.4058 9.06817C14.6312 8.85429 14.8845 8.67191 15.1588 8.52602C15.452 8.37532 15.7609 8.25747 16.08 8.17462C16.5964 8.04813 17.1272 7.9899 17.6588 8.00143C18.2222 8.01411 18.7823 8.09159 19.3279 8.23235C20.2842 8.48335 21.11 9.06315 21.9132 9.62539C22.1065 9.76093 22.2972 9.89396 22.5031 10.032L23.6702 10.8076H23.6777ZM3.95928 17.7301C4.09154 17.7296 4.22097 17.7684 4.33115 17.8416C4.44133 17.9148 4.52729 18.019 4.57814 18.1411C4.62898 18.2632 4.64241 18.3977 4.61673 18.5274C4.59105 18.6572 4.52741 18.7764 4.43389 18.8699C4.34036 18.9634 4.22117 19.0271 4.09142 19.0527C3.96168 19.0784 3.82723 19.065 3.70513 19.0141C3.58302 18.9633 3.47878 18.8773 3.40561 18.7672C3.33243 18.657 3.29363 18.5275 3.29413 18.3953C3.29479 18.2191 3.36508 18.0503 3.48968 17.9257C3.61427 17.8011 3.78307 17.7308 3.95928 17.7301ZM21.6773 20.7823C21.6243 20.7592 21.5771 20.7247 21.5389 20.6814C21.5007 20.638 21.4726 20.5868 21.4564 20.5313L17.586 13.546C17.1568 12.8281 16.7703 12.8081 16.3938 13.0314C16.0963 13.2281 15.8181 13.4525 15.563 13.7016C15.3923 13.8572 15.2216 14.0128 15.081 14.1283L14.3958 14.6931C13.9592 15.0482 13.4274 15.2666 12.8672 15.3206C12.539 15.3499 12.2083 15.3071 11.8984 15.1951C11.5932 15.0821 11.3237 14.8898 11.1178 14.6378C10.8836 14.3422 10.7445 13.9825 10.7187 13.6062C10.7147 13.5501 10.7227 13.4938 10.7422 13.441C10.7617 13.3882 10.7921 13.3401 10.8316 13.3L12.9224 10.8126C12.5135 10.8027 12.1058 10.8595 11.7151 10.9808C11.1206 11.1887 10.5598 11.483 10.051 11.8543C9.98011 11.9113 9.89095 11.9407 9.80002 11.9371H7.3829V19.4671H8.80606C8.8776 19.467 8.94779 19.4866 9.00889 19.5238C9.07 19.561 9.11967 19.6143 9.15244 19.6779L10.9094 22.7275C11.1049 23.126 11.3587 23.4932 11.6624 23.8169C11.9829 24.0881 12.3924 24.2312 12.812 24.2185C13.0097 24.2241 13.2064 24.1882 13.3893 24.113C13.5066 24.0649 13.6172 24.0016 13.7181 23.9248L12.5861 21.8064C12.5455 21.717 12.5404 21.6155 12.5719 21.5225C12.6034 21.4295 12.6691 21.352 12.7557 21.3056C12.8422 21.2593 12.9432 21.2477 13.038 21.2731C13.1329 21.2985 13.2145 21.359 13.2663 21.4424L14.5062 23.7591C14.8586 23.9844 15.2824 24.0697 15.6945 23.9981C16.1065 23.9266 16.4768 23.7034 16.7326 23.3726L14.948 20.5664C14.8921 20.4805 14.8726 20.376 14.8938 20.2757C14.915 20.1755 14.9751 20.0877 15.061 20.0318C15.1478 19.9777 15.2524 19.9598 15.3523 19.9818C15.4522 20.0039 15.5396 20.0641 15.5956 20.1498L17.4756 23.104C17.7739 23.2362 18.108 23.2645 18.4243 23.1843C18.758 23.0791 19.0566 22.8847 19.2878 22.6221L17.5885 19.4143C17.5396 19.3235 17.5288 19.2169 17.5584 19.118C17.5881 19.0192 17.6558 18.9362 17.7466 18.8872C17.8375 18.8383 17.9441 18.8275 18.0429 18.8571C18.1418 18.8868 18.2248 18.9545 18.2737 19.0454L20.0307 22.3636C20.2591 22.4928 20.5258 22.5372 20.7837 22.4891C21.0086 22.4532 21.2204 22.3598 21.3987 22.218C21.5668 22.0902 21.6934 21.9155 21.7626 21.716C21.839 21.4667 21.8184 21.1977 21.7049 20.963C21.6803 20.907 21.67 20.8458 21.6748 20.7848L21.6773 20.7823ZM26.7776 17.7301C26.9095 17.7311 27.0382 17.7712 27.1474 17.8453C27.2566 17.9193 27.3414 18.0241 27.3911 18.1463C27.4407 18.2686 27.4531 18.4028 27.4266 18.532C27.4 18.6613 27.3358 18.7798 27.242 18.8725C27.1482 18.9653 27.029 19.0282 26.8994 19.0533C26.7699 19.0783 26.6358 19.0645 26.5142 19.0134C26.3925 18.9623 26.2887 18.8764 26.2159 18.7664C26.143 18.6564 26.1044 18.5272 26.1049 18.3953C26.1056 18.2191 26.1758 18.0503 26.3004 17.9257C26.425 17.8011 26.5938 17.7308 26.77 17.7301H26.7776Z"
                                  fill="black"
                                  fillOpacity="0.6"
                                />
                              </svg>{" "}
                              Onboardings
                            </Nav.Link>
                          </Nav.Item>
                        )}
                        {!userDetailState?.roles?.includes("customer") &&
                          localStorage.getItem(
                            SessionKeys.SHOW_MENTER_COACH
                          ) !== "false" && (
                            <Nav.Item>
                              <Nav.Link eventKey="coachingnotes">
                                <svg
                                  width="32"
                                  height="32"
                                  viewBox="0 0 32 32"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M10.6003 10.1015H20.8949C20.9457 10.1015 20.988 10.1438 20.988 10.1946C20.988 10.8612 20.988 10.4168 20.988 11.0812C20.988 11.132 20.9457 11.1743 20.8949 11.1743H10.6003C10.5389 11.1743 10.4882 11.1235 10.4882 11.0622C10.4882 10.4083 10.4882 10.8654 10.4882 10.2115C10.4882 10.1523 10.5389 10.1015 10.6003 10.1015ZM7.95735 4.52991H9.60999V3.49304C9.60999 3.22219 9.88085 3 10.2131 3C10.5453 3 10.8161 3.22219 10.8161 3.49304V4.52779H13.4401V3.49304C13.4401 3.22219 13.7109 3 14.041 3C14.3732 3 14.6441 3.22219 14.6441 3.49304V4.52779H17.268V3.49304C17.268 3.22219 17.5389 3 17.8711 3C18.2033 3 18.4742 3.22219 18.4742 3.49304V4.52779H21.0981V3.49304C21.0981 3.22219 21.3689 3 21.7011 3C22.0334 3 22.3042 3.22219 22.3042 3.49304V4.52779H23.5188C24.5959 4.52779 25.4762 5.40807 25.4762 6.48515V27.0426C25.4762 28.1197 24.5959 29 23.5188 29H7.95735C6.88028 29 6 28.1197 6 27.0426V6.48726C6 5.41019 6.88028 4.52991 7.95735 4.52991ZM8.11394 6.19525H9.60999V6.92952C9.60999 7.20037 9.88085 7.42256 10.2131 7.42256C10.5453 7.42256 10.8161 7.20037 10.8161 6.92952V6.19525H13.4401V6.92952C13.4401 7.20037 13.7109 7.42256 14.0431 7.42256C14.3754 7.42256 14.6462 7.20037 14.6462 6.92952V6.19525H17.2701V6.92952C17.2701 7.20037 17.541 7.42256 17.8732 7.42256C18.2054 7.42256 18.4763 7.20037 18.4763 6.92952V6.19525H21.1002V6.92952C21.1002 7.20037 21.371 7.42256 21.7033 7.42256C22.0355 7.42256 22.3063 7.20037 22.3063 6.92952V6.19525H23.3644C23.667 6.19525 23.9167 6.44494 23.9167 6.74754V26.7824C23.9167 27.0829 23.667 27.3347 23.3644 27.3347H8.11394C7.81346 27.3347 7.56165 27.0871 7.56165 26.7824V6.74754C7.56165 6.44494 7.81135 6.19525 8.11394 6.19525ZM10.6003 25.1953H20.8949C20.9457 25.1953 20.988 25.153 20.988 25.1022C20.988 24.4357 20.988 24.88 20.988 24.2156C20.988 24.1648 20.9457 24.1225 20.8949 24.1225H10.6003C10.5389 24.1225 10.4882 24.1733 10.4882 24.2346C10.4882 24.8123 10.4882 24.5076 10.4882 25.0853C10.4882 25.1445 10.5389 25.1953 10.6003 25.1953ZM10.6003 21.6911H20.8949C20.9457 21.6911 20.988 21.6488 20.988 21.598C20.988 20.9315 20.988 21.4774 20.988 20.813C20.988 20.7622 20.9457 20.7199 20.8949 20.7199H10.6003C10.5389 20.7199 10.4882 20.7707 10.4882 20.832C10.4882 21.4859 10.4882 20.9272 10.4882 21.5811C10.4882 21.6404 10.5389 21.6911 10.6003 21.6911ZM10.6003 18.1848H20.8949C20.9457 18.1848 20.988 18.1425 20.988 18.0917C20.988 17.4252 20.988 17.768 20.988 17.1035C20.988 17.0527 20.9457 17.0104 20.8949 17.0104H10.6003C10.5389 17.0104 10.4882 17.0612 10.4882 17.1226C10.4882 17.7764 10.4882 17.4209 10.4882 18.0748C10.4882 18.134 10.5389 18.1848 10.6003 18.1848ZM10.6003 14.6806H20.8949C20.9457 14.6806 20.988 14.6383 20.988 14.5875C20.988 13.921 20.988 14.3653 20.988 13.7009C20.988 13.6501 20.9457 13.6078 20.8949 13.6078H10.6003C10.5389 13.6078 10.4882 13.6586 10.4882 13.7199C10.4882 14.3738 10.4882 13.9167 10.4882 14.5706C10.4882 14.6299 10.5389 14.6806 10.6003 14.6806Z"
                                    fill="black"
                                    fillOpacity="0.6"
                                  />
                                </svg>{" "}
                                Coaching Notes
                              </Nav.Link>
                            </Nav.Item>
                          )}
                      </>
                    )}
                  </Nav>
                </Col>
                <Col className="col-xl-9 col-lg-9">{renderComp()}</Col>
              </Row>
            </Tab.Container>
          </div>
        </section>
      </section>
      <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={showModalMsg}
        isConfirm={isConfirm}
        isRightIcon={true}
        noAction={() => {}}
      />
      <SimplePopup
        confirmModal={showLimitPopup}
        setConfirmModal={setShowLimitPopup}
        showModalMsg={"File size exceeds 1 MB. Please choose a smaller file."}
        isRightIcon={false}
      />
    </>
  );
};
export default MenuDetailComponent;
